import { FC } from 'react';

type Props = {
	className?: string;
};

const AnalyticsIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6.31641 13.6842V10.7368'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M10.0005 13.6843V6.31592'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M13.6841 13.6842V9.26318'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M3.00049 9.99992C3.00049 6.70013 3.00049 5.05023 4.0256 4.02511C5.05072 3 6.70062 3 10.0004 3C13.3002 3 14.9501 3 15.9752 4.02511C17.0003 5.05023 17.0003 6.70013 17.0003 9.99992C17.0003 13.2997 17.0003 14.9496 15.9752 15.9748C14.9501 16.9998 13.3002 16.9998 10.0004 16.9998C6.70062 16.9998 5.05072 16.9998 4.0256 15.9748C3.00049 14.9496 3.00049 13.2997 3.00049 9.99992Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default AnalyticsIcon;
